import { render } from "./Room.vue?vue&type=template&id=134c15d1"
import script from "./Room.vue?vue&type=script&lang=js"
export * from "./Room.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./Room.vue?vue&type=style&index=0&id=134c15d1&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__